import script from "./AppNoResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNoResult.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__